import React, { useState } from "react";
import _ from "lodash";
import { BORDER } from "../../constants/AppColors";
import Button from "../base/Button";
import Glyphicon from "../base/Glyphicon";
import LinkEntryModal from "./LinkEntryModal";
import uiPrefix from "../../utils/UiPrefixUtils";

const TextToolBar = ({ selectionInfo = null, linkWarningEnabled = false, onAction }) => {
  const [showLinkModal, setShowLinkModal] = useState(false);

  const _saveLink = (link) => {
    link ? onAction("createLink", link) : onAction("unlink");
    setShowLinkModal(false);
  };

  const toolbarStyle = {
    backgroundColor: BORDER,
    height: 35,
    paddingLeft: 5,
    paddingRight: 5,
    width: 240,
    borderRadius: 4,
  };

  const btnStyle = {
    paddingLeft: 4,
    paddingRight: 3,
    fontSize: 14,
    position: "relative",
  };

  const commitBtnStyle = {
    position: "absolute",
    right: 2,
    top: 2,
    paddingLeft: 5,
    paddingRight: 5,
    fontSize: 15,
    lineHeight: "1.15em",
  };

  const collapsed = _.get(selectionInfo, "collapsed", true);
  const selectionAnchor = _.get(selectionInfo, "anchorEl", false);
  const unlinkEnabled = !!selectionAnchor;
  const linkEnabled = !collapsed || (collapsed && unlinkEnabled);
  const selectionHREF = _.get(selectionInfo, "href", "");

  return (
    <div style={toolbarStyle}>
      <Button
        look="link"
        data-e2e={uiPrefix("format-bold-btn")}
        className={uiPrefix("format-bold-btn")}
        style={btnStyle}
        onClick={() => onAction("bold")}
      >
        <Glyphicon glyph="bold" />
      </Button>
      <Button
        look="link"
        data-e2e={uiPrefix("format-italic-btn")}
        className={uiPrefix("format-italic-btn")}
        style={btnStyle}
        onClick={() => onAction("italic")}
      >
        <Glyphicon glyph="italic" />
      </Button>
      <Button
        look="link"
        data-e2e={uiPrefix("format-strikethrough-btn")}
        className={uiPrefix("format-strikethrough-btn")}
        style={btnStyle}
        onClick={() => onAction("strikeThrough")}
        title="Strikethrough"
      >
        <Glyphicon icon="strikethrough" style={{ fontSize: 16 }} />
      </Button>
      <Button
        look="link"
        data-e2e={uiPrefix("format-unordered-list-btn")}
        className={uiPrefix("format-unordered-list-btn")}
        style={btnStyle}
        onClick={() => onAction("ul")}
        title="Unordered List"
      >
        <Glyphicon icon="unordered-list" style={{ fontSize: 16 }} />
      </Button>
      <Button
        look="link"
        data-e2e={uiPrefix("format-ordered-list-btn")}
        className={uiPrefix("format-ordered-list-btn")}
        style={btnStyle}
        onClick={() => onAction("ol")}
        title="Ordered List"
      >
        <Glyphicon icon="ordered-list" style={{ fontSize: 16 }} />
      </Button>
      <Button
        look="link"
        data-e2e={uiPrefix("create-link-btn")}
        className={uiPrefix("create-link-btn")}
        style={btnStyle}
        onClick={() => setShowLinkModal(true)}
        disabled={!linkEnabled}
        title="Create Link"
      >
        <Glyphicon icon="link" style={{ fontSize: 16 }} />
      </Button>
      <Button
        look="link"
        data-e2e={uiPrefix("unlink-btn")}
        className={uiPrefix("unlink-btn")}
        style={btnStyle}
        onClick={() => onAction("unlink")}
        title="Remove Link"
        disabled={!unlinkEnabled}
      >
        <Glyphicon icon="link-unlink" style={{ fontSize: 16 }} />
      </Button>
      <Button
        look="link"
        data-e2e={uiPrefix("clear-formatting-btn")}
        className={uiPrefix("clear-formatting-btn")}
        style={btnStyle}
        onClick={() => onAction("clearFormat")}
        title="Clear Formatting"
      >
        <Glyphicon glyph="ban" />
      </Button>
      <Button
        look="primary"
        data-e2e={uiPrefix("complete-editing-btn")}
        className={uiPrefix("complete-editing-btn")}
        style={commitBtnStyle}
        onClick={() => onAction("complete")}
        title="Complete Editing"
      >
        <Glyphicon icon="check" />
      </Button>
      <LinkEntryModal
        href={selectionHREF}
        linkWarningEnabled={linkWarningEnabled}
        show={showLinkModal}
        onHide={() => setShowLinkModal(false)}
        onCancel={() => setShowLinkModal(false)}
        onSave={_saveLink}
      />
    </div>
  );
};

export default TextToolBar;
